// frontend/src/components/Layout/ProfileMenu.jsx

import React, { useState, useEffect } from "react";
import api from "../../../api";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  avatarState,
  usernameState,
} from "../../../Recoil/atom";
import { useRecoilValue } from "recoil";
import {
  getMiningLevel,
  getCatcherLevel,
  getLevel,
} from "../../../constants/items";

const ProfileMenu = (props) => {
  const avatar = useRecoilValue(avatarState);
  const username = useRecoilValue(usernameState);

  const [money, setMoney] = useState(0);
  const [coins, setCoins] = useState(0);
  const [battleCoins, setBattleCoins] = useState(0);
  const [pokedex, setPokedex] = useState(0);
  const [miningLevel, setMiningLevel] = useState(0);
  const [batteLevel, setBatteLevel] = useState(0);
  const [catcherLevel, setCatcherLevel] = useState(0);
  const [admValue, setAdmValue] = useState(0); // raw integer from server
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [promo, setPromo] = useState("");

  // Two derived booleans:
  const isAdmin = admValue === 1;
  const isSpriter = admValue === 2;

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);

    // Only fetch once per open
    if (!menuOpen && !loading) {
      setLoading(true);
      api
        .get("/v1/menu/details", { withCredentials: true })
        .then((response) => {
          if (response.data) {
            const data = response.data;

            setMoney(data.money);
            
            setCoins(data.coins);
            setPokedex(data.pokedex_count);

            // 'adm' is now returned as an integer
            setAdmValue(data.adm);

            setBatteLevel(data.trainer_exp)
            setCatcherLevel(data.catcher_exp);
            setBattleCoins(data.battle_coins);
            setMiningLevel(data.mining_exp);
            setPromo(data.current_promo || "");
          }
        })
        .catch((error) => {
          console.error("Error fetching menu details:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const avatarSrc = `/avatars/${avatar}.png`;
  const moneySrc = `/items/money.png`;
  const coinsSrc = `/items/coin.png`;
  const battleCoinsSrc = `/items/battle_coin.png`;
  const ballSrc = `/items/pokeball.png`;
  const pickSrc = `/items/NormalPickaxe.png`;
  const battleSrc = `/items/battleseek.png`;
  const dexSrc = `/items/pokedex.png`;
  const promoSrc = promo ? `/icon/${promo}.png` : "";

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menuOpen}
        toggle={toggleMenu}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          tag="button"
          id="page-header-user-dropdown"
        >
          <img
            className="rounded-circle header-profile-user"
            src={avatarSrc}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-2">
            {username}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>

        <DropdownMenu>
          {loading ? (
            <div className="text-center p-3">
              <Spinner size="sm" />
            </div>
          ) : (
            <>
              {/* Promote Center */}
              <DropdownItem
                className="d-flex flex-column align-items-center"
                tag={Link}
                to="/promo-center"
              >
                {promo && (
                  <img
                    alt={promo}
                    src={promoSrc}
                    style={{
                      width: 48,
                      height: 48,
                      marginBottom: 4,
                    }}
                  />
                )}
                <span>Promo Center</span>
              </DropdownItem>

              <DropdownItem divider />

              {/* Money */}
              <DropdownItem className="d-flex align-items-center">
                <img
                  src={moneySrc}
                  alt="Money"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                {money.toLocaleString()}
              </DropdownItem>

              {/* Coins */}
              <DropdownItem className="d-flex align-items-center">
                <img
                  src={coinsSrc}
                  alt="Coins"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                {coins.toLocaleString()}
                
              </DropdownItem>

                <DropdownItem className="d-flex align-items-center">
                <img
                  src={battleCoinsSrc}
                  alt="Coins"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                {battleCoins.toLocaleString()}

                
                
              </DropdownItem>
<DropdownItem className="d-flex align-items-center">
                <img
                  src={dexSrc}
                  alt="Pokedex"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                {pokedex.toLocaleString()}
              </DropdownItem>
              <DropdownItem divider />

               <DropdownItem
                className="d-flex align-items-center"
                tag={Link}
                to="/department-store"
              >
                <img
                  src={battleSrc}
                  alt="Mining"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                lvl {getLevel(batteLevel).toLocaleString()}
              </DropdownItem>

              {/* Mining Level */}
              <DropdownItem
                className="d-flex align-items-center"
                tag={Link}
                to="/department-store"
              >
                <img
                  src={pickSrc}
                  alt="Mining"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                lvl {getMiningLevel(miningLevel).toLocaleString()}
              </DropdownItem>

              {/* Catcher Level */}
              <DropdownItem
                className="d-flex align-items-center"
                tag={Link}
                to="/department-store"
              >
                <img
                  src={ballSrc}
                  alt="Pokéball"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                lvl {getCatcherLevel(catcherLevel).toLocaleString()}
              </DropdownItem>

              {/* Pokédex Count */}
          

              {/* If admValue === 2, show Spriter Panel link */}
              {isSpriter && (
                <>
                  <DropdownItem divider />
                  <DropdownItem tag={Link} to="/spriter-dashboard">
                    <i className="ri-pencil-ruler-2-line align-middle me-2" />
                    {props.t("Spriter Panel")}
                  </DropdownItem>
                </>
              )}

              {/* If admValue === 1, show Admin Panel link */}
              {isAdmin && (
                <>
                  <DropdownItem divider />
                  <DropdownItem tag={Link} to="/admin-panel">
                    <i className="ri-shield-user-line align-middle me-2" />
                    {props.t("Admin Panel")}
                  </DropdownItem>
                </>
              )}

              <DropdownItem divider />

              {/* Always show Profile & Settings & Logout */}
              <DropdownItem tag={Link} to="/profile">
                <i className="ri-user-line align-middle me-2" />
                {props.t("Profile")}
              </DropdownItem>
              <DropdownItem tag={Link} to="/settings">
                <i className="ri-settings-2-line align-middle me-2" />
                {props.t("Settings")}
              </DropdownItem>

              <DropdownItem divider />

              <DropdownItem tag={Link} to="/logout">
                <i className="ri-shut-down-line align-middle me-2 text-danger" />
                {props.t("Logout")}
              </DropdownItem>
            </>
          )}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ProfileMenu);
